<template>
  <!-- 全局时间选择 -->
  <div class="date-wrap">
    <p class="name">
      {{ name }}
    </p>
    <div class="date-select">
      <div class="left">
        <VueDatePicker
          ref="datePicker"
          v-model="dateValue"
          format="yyyy/M/dd"
          locale="zhCN"
          :day-names="[$t('星期一'),$t('星期二'),$t('星期三'),$t('星期四'),$t('星期五'),$t('星期六'),$t('星期日')]"
          :min-date="new Date()"
          :format-locale="zhCN"
          :enable-time-picker="false"
          :clearable="false"
          :close-on-scroll="!store.state.isMobile"
          :transitions="!store.state.isMobile"
          :teleport-center="store.state.isMobile"
          :timezone="modelTimezone"
          :action-row="{ showPreview: false }"
        >
          <template #input-icon>
            <img class="input-slot-image" src="../../assets/img/icons/icon-date.png" />
          </template>
          <template #action-buttons>
            <p class="custom-select" @click="cancelSelectDate">{{ $t("取消") }}</p>
            <p class="custom-select sure" @click="selectDate">{{ $t("确认") }}</p>
          </template>
        </VueDatePicker>
      </div>
      <div class="right">
        <VueDatePicker
          ref="timePicker"
          v-model="timeValue"
          time-picker
          locale="zhCN"
          :day-names="[$t('星期一'),$t('星期二'),$t('星期三'),$t('星期四'),$t('星期五'),$t('星期六'),$t('星期日')]"
          :clearable="false"
          :close-on-scroll="!store.state.isMobile"
          :teleport-center="store.state.isMobile"
          :transitions="!store.state.isMobile"
          :action-row="{ showPreview: false }"
        >
          <template #input-icon>
            <img class="input-down-image" src="../../assets/img/icons/icon-arr-down.png" />
          </template>
          <template #action-buttons>
            <p class="custom-select" @click="cancelSelectTime">{{ $t("取消") }}</p>
            <p class="custom-select sure" @click="selectTime">{{ $t("确认") }}</p>
          </template>
        </VueDatePicker>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watchEffect, computed } from 'vue';
import { format } from 'date-fns';
import { zhCN } from 'date-fns/locale';
import { useStore } from 'vuex';

const store = useStore();

const props = defineProps({
  name: String,
  modelValue: String,
  modelTimeValue: String,
  modelTimezone: String
})

const emit = defineEmits([
  "update:modelValue",
  "update:modelTimeValue"
]);
// const dateValue = ref(new Date());
// const timeValue = ref(new Date().getTime());
const datePicker = ref();
const timePicker = ref();

onMounted(() => {
  // console.log('props.modelTimeValue :>> ', props.modelTimeValue);
})

// const dateValue = computed({
//   get() {
//     return props.modelValue;
//   },
//   set(value) {
//     emit('update:modelValue', value);
//   }
// })

// const timeValue = computed({
//   get() {
//     return props.modelTimeValue;
//   },
//   set(value) {
//     console.log('value :>> ', value);
//     emit('update:modelTimeValue', value);
//   }
// })

function cancelSelectDate() {
  datePicker.value.closeMenu();
}

function selectDate() {
  datePicker.value.selectDate();
}

function cancelSelectTime() {
  timePicker.value.closeMenu();
}

function selectTime() {
  timePicker.value.selectDate();
}

const dateValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  }
})

const timeValue = computed({
  get() {
    return props.modelTimeValue;
  },
  set(value) {
    console.log('value :>> ', value);
    emit('update:modelTimeValue', value);
  }
})

// watchEffect(() => {
//   emit("update:modelValue", format(new Date(dateValue.value), "yyyy-MM-dd EEEE", { locale: zhCN }));
//   emit("update:modelTimeValue", timeValue.value);
// })
</script>

<style scoped>
.date-wrap {
  width: 30.20833vw;
  margin: 0 auto;
}

.date-wrap .name {
  font-size: 0.9375vw;
  line-height: 1.30208vw;
  font-weight: bold;
  color: #2F3367;
  margin-bottom: 0.41666vw;
}

::v-deep .dp__input_icon {
  right: 1.25vw;
}

.input-slot-image {
  width: 1.25vw;
  height: 1.25vw;
}

.input-down-image {
  width: 1.14583vw;
  height: 1.04166vw;
}

.date-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.date-select .left {
  width: 19.27083vw;
}

.date-select .right {
  width: 9.89583vw;
}

::v-deep .dp__input {
  font-size: 0.83333vw;
  padding: 0.72916vw 1.25vw;
  border-radius: 0.20833vw;
}

::v-deep .dp__input_icon {
  left: auto;
  right: 1.25vw;
}

@media screen and (max-width: 750px) {

  .date-wrap {
    width: 82.93333vw;
  }

  .date-wrap .name {
    font-size: 3.73333vw;
    line-height: 5.33333vw;
    margin-bottom: 1.6vw;
  }

  .date-select .left {
    width: 48.8vw;
  }

  .date-select .right {
    width: 30.93333vw;
  }

  ::v-deep .dp__input {
    font-size: 3.73333vw;
    padding: 2.66666vw 3.2vw;
    border-radius: 0.53333vw;
  }

  .input-slot-image {
    width: 4.26666vw;
    height: 4.26666vw;
  }

  .input-down-image {
    width: 4.26666vw;
    height: auto;
  }

  ::v-deep .dp__input_icon {
    right: 3.2vw;
  }

}
</style>

<style>
.dp__clear_icon {
  padding: 0;
}

.custom-select {
  width: 5.625vw;
  box-sizing: border-box;
  font-size: 0.83333vw;
  line-height: 2.39583vw;
  color: #B41D23;
  text-align: center;
  border: 0.05208vw solid #B41D23;
  border-radius: 0.41666vw;
  cursor: pointer;
}

.custom-select.sure {
  color: #fff;
  background: #B41D23;
  border: none;
  margin-left: 1.25vw;
}

.dp__today {
  border-color: #B41D23;
}

.dp__active_date {
  background: #B41D23;
}

@media screen and (max-width: 750px) {

  .custom-select {
    width: 18.13333vw;
    font-size: 3.73333vw;
    line-height: 8.26666vw;
    text-align: center;
    white-space: nowrap;
    border-radius: 1.06666vw;
    box-sizing: border-box;
    color: #B41D23;
    border: 0.13333vw solid #B41D23;
	margin-bottom: 0.20833vw;
  }

  .custom-select.sure {
    line-height: 8.53333vw;
    color: #fff;
    border: none;
    background: #B41D23;
    margin-left: 3.2vw;
  }

}
</style>
